import { v4 as uuidv4 } from 'uuid';

const clean = (obj) => {
  for (const propName in obj) {
    if (obj[propName] === null || obj[propName] === undefined || obj[propName] === '') {
      delete obj[propName];
    }
  }

  return obj;
};

export const userSendOtpClassOpts = (data) => {
  const opts = {
    _meta: {
      class: 'UserSendOtpRequest',
    },
    'transactionID': uuidv4(),
    'data': {
      ...data,
    },
  };

  return opts;
};

export const userGetOtpClassOpts = (data) => {
  const opts = {
    _meta: {
      class: 'UserGetOtpRequest',
    },
    'transactionID': uuidv4(),
    'data': {
      ...data,
    },
  };

  return opts;
};

export const userSignInClassOpts = (clubPremierNumber, email, password, sessionID, enteredOtp, ipAddress) => {
  // revisando peticion de opts
  const opts = {
    _meta: {
      class: 'UserProfileSignInRequest',
    },
    clubPremierNumber: clubPremierNumber || '',
    email: email || '',
    password: password || '',
    sessionId: sessionID || '',
    otpCode: enteredOtp || '',
    ipAddress: ipAddress ? ipAddress : '127.0.0.1',
  };

  return clean(opts);
};

export const userSignUpClassOpts = (data) => {
  const opts = {
    _meta: {
      class: 'UserProfileSignUpRequest',
    },
    'transactionID': uuidv4(),
    'data': {
      ...data,
    },
  };

  return opts;
};

export const userSignOutClassOpts = (userToken) => {
  const opts = {
    _meta: {
      class: 'UserProfileSignOutRequest',
    },
    userToken: (userToken) ? userToken : '',
  };

  return opts;
};

export const userProfileRegistrationEmailValidationClassOpts = (data) => {
  // revisando peticion de opts
  const opts = {
    _meta: {
      class: 'userProfileRegistrationEmailValidation',
    },
    email: data,
  };

  return opts;
};

export const userProfileRegistrationTutorValidationClassOpts = (data) => {
  // revisando peticion de opts
  const opts = {
    _meta: {
      class: 'userProfileRegistrationTutorValidation',
    },
    email:'example@aeromexico.com',
    guardianAccount: data.guardianAccount,
    duplicateEmail: false,
  };

  return opts;
};
